import React, { useState, useEffect } from 'react'
import { node, object, string } from 'prop-types'
import { urlPathToObject } from '../../helpers/common'
import { EMPTY_OBJECT } from '../../utils/constants'
import { FILTERS_CATEGORIES_KEYS } from '../../components/filters/constants'

const FiltersStateContext = React.createContext(EMPTY_OBJECT)

const getCategories = (filtersObject, type) => {
  // eslint-disable-next-line max-len
  const splittedCategories = filtersObject.hasOwnProperty(FILTERS_CATEGORIES_KEYS[type]) && filtersObject[FILTERS_CATEGORIES_KEYS[type]].split('_')
  const categories = splittedCategories.length > 0 && splittedCategories.reduce((acc, curr, idx) => {
    const categoryKey = `${FILTERS_CATEGORIES_KEYS[type]}_${idx + 1}`
    acc[categoryKey] = curr
    return acc
  }, {})
  return categories || EMPTY_OBJECT
}

const FiltersProvider = ({ children, location, type }) => {
  const [filtersObject, setFiltersObject] = useState(EMPTY_OBJECT)
  const [activeCategories, setActiveCategories] = useState(EMPTY_OBJECT)
  useEffect(() => {
    const filtersObj = urlPathToObject(location, type)
    const activeCategories = getCategories(filtersObj, type)
    setFiltersObject(filtersObj)
    setActiveCategories(activeCategories)
  }, [location])
  return (
    <FiltersStateContext.Provider value={{ filtersObject, activeCategories }}>
      {children}
    </FiltersStateContext.Provider>
  )
}

FiltersProvider.propTypes = {
  children: node,
  location: object,
  type: string
}

function useFiltersState () {
  const context = React.useContext(FiltersStateContext)
  if (context === undefined) {
    throw new Error('useFiltersState must be used within a FiltersProvider')
  }
  return context
}

export { FiltersProvider, useFiltersState }
